import styled from "styled-components";
import { extendedSystemStyles } from "@mixins";
var styledSystemKeys = ["space", "layout", "flexbox"];
export var TargetContainer = styled.div.withConfig({
  displayName: "metaInformationstyles__TargetContainer",
  componentId: "sc-1plzm0b-0"
})(["", ""], function (_ref) {
  var theme = _ref.theme;
  return "\n    background: ".concat(theme.colors.T1, ";\n    &:first-child{\n      margin-top: 20px;\n    }\n    &:last-child{\n      margin-bottom: 20px;\n    }\n  ");
});
export var TargetValue = styled.div.withConfig({
  displayName: "metaInformationstyles__TargetValue",
  componentId: "sc-1plzm0b-1"
})(["", ""], function (_ref2) {
  var theme = _ref2.theme,
    idx = _ref2.idx;
  return "\n    font-family: ".concat(theme.fonts.robotoMedium, ";\n    font-size: ").concat(theme.fontSizes.xxl, ";\n    padding: 0 ").concat(theme.space.sm, ";\n\n    height: 50px;\n    width: fit-content;\n    display: flex;\n    align-items: center;\n\n    background: ", "".concat(theme.colors.C1).concat(theme.colors.opacitySuffix[idx]), ";\n  ");
});
export var TextContainer = styled.div.withConfig({
  displayName: "metaInformationstyles__TextContainer",
  componentId: "sc-1plzm0b-2"
})(["", "", ""], function (_ref3) {
  var theme = _ref3.theme;
  return "\n    padding: ".concat(theme.space.xs, " ").concat(theme.space.sm, ";\n  ");
}, extendedSystemStyles(styledSystemKeys));